export default function(options) {
  const defaults = {
    productTagLine: {
      'default': null
    },
    productLongDescription: {
      'default': null
    },
    marketplace: false,
    listOrder: 99,
    eula: null,
    moreLink: null,
    universityParent: null,
    recommendedProducts: [],
    images: {
      xxx: null,
      xx: null
    },
    onDemand: {
      available: false,
      key: null,
      crossSell: null
    }
  };

  return Object.assign(this, defaults, options);
}
